var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 154,
    viewBox: "0 0 141 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0816 77.5972C-28.5388 55.0855 13.5521 15.0646 40.5549 0H141.493V149.225C130.976 155.479 110.284 159.799 111.648 127.055C113.353 86.1244 98.8571 105.737 28.0816 77.5972Z",
    fill: "#FF3900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner1);
export default __webpack_public_path__ + "static/media/corner1.87ac377431abea2eee34c3dbb7c8c0a4.svg";
export { ForwardRef as ReactComponent };